module.exports = __webpack_public_path__ + "img/nlic_gallery3.5ed2de2f.jpg";